class Dismiss {

    /**
     * @since 4.7.0
     * @method constructor
     */
    constructor() {
        // Declare and initialize
        this.selector = '[data-ll-dismiss]';

        // Run initialization
        this.init();
    }

    /**
     * Initialize the class.
     *
     * @method init
     * @since 4.18.0
     * @returns object The initialized map
     */
    init() {
        // If there are no countdowns, bail
        if (!$(this.selector).length) return;

        // Bind the clicker
        $(this.selector).on('click touch tap scroll touchstart mousedown', function (e) {

            // Declare and initialize
            let target = $(e.target);

            // If this is the wrong target, look for the right one
            if (!target.is('[data-dismiss]'))
                target = $(e.target).closest('[data-dismiss]');

            // Just hide it, I guess
            target.hide();

        });

        // Prevent leaks
        return;
    }

}

export default Dismiss;